var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ModalWrapper,{attrs:{"icon":"qrcode","title":_vm.title,"type":_vm.type},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c(_setup.QRCode,{attrs:{"text":_setup.qrCodePath,"color":"#db2980","bg-color":"#000"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }